import ShareIcon from '@mui/icons-material/Share';
import { ReactNode, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ActionButtonGroupAction } from '@/components/ActionButtonGroup/ActionButtonGroup';
import { ShareModal } from '@/components/Share/ShareModal';
import { useBreakpoint } from '@/utils/useBreakpoint';

export const useShareAction = (): {
	action: ActionButtonGroupAction;
	modal: ReactNode;
} => {
	const { t } = useTranslation();
	const [open, setOpen] = useState(false);
	const isCollapsed = useBreakpoint('lg', 'down');

	return {
		action: {
			key: 'share',
			label: t('Share'),
			icon: <ShareIcon fontSize={isCollapsed ? 'inherit' : undefined} />,
			onClick: () => setOpen(true),
			variant: 'outlined',
			iconOnly: isCollapsed
		},
		modal: (
			<ShareModal
				open={open}
				onClose={() => setOpen(false)}
				title={t('Share this profile')}
				description={t('Copy and paste the link above to share this profile.')}
			/>
		)
	};
};
